import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import damageWaiver_en from './locales/en/damageWaiver.json';
import damageWaiverResult_en from './locales/en/damageWaiverResult.json';
import portal_en from './locales/en/portal.json';
import damageWaiver_es from './locales/es/damageWaiver.json';
import damageWaiverResult_es from './locales/es/damageWaiverResult.json';
import portal_es from './locales/es/portal.json';
import damageWaiver_fr from './locales/fr/damageWaiver.json';
import damageWaiverResult_fr from './locales/fr/damageWaiverResult.json';
import portal_fr from './locales/fr/portal.json';
import damageWaiver_de from './locales/de/damageWaiver.json';
import damageWaiverResult_de from './locales/de/damageWaiverResult.json';
import portal_de from './locales/de/portal.json';
import damageWaiver_pt from './locales/pt/damageWaiver.json';
import damageWaiverResult_pt from './locales/pt/damageWaiverResult.json';
import portal_pt from './locales/pt/portal.json';
import damageWaiver_it from './locales/it/damageWaiver.json';
import damageWaiverResult_it from './locales/it/damageWaiverResult.json';
import portal_it from './locales/it/portal.json';
import damageWaiver_zh from './locales/zh/damageWaiver.json';
import damageWaiverResult_zh from './locales/zh/damageWaiverResult.json';
import portal_zh from './locales/zh/portal.json';
import damageWaiver_ja from './locales/ja/damageWaiver.json';
import damageWaiverResult_ja from './locales/ja/damageWaiverResult.json';
import portal_ja from './locales/ja/portal.json';
import damageWaiver_ko from './locales/ko/damageWaiver.json';
import damageWaiverResult_ko from './locales/ko/damageWaiverResult.json';
import portal_ko from './locales/ko/portal.json';
import damageWaiver_nl from './locales/nl/damageWaiver.json';
import damageWaiverResult_nl from './locales/nl/damageWaiverResult.json';
import portal_nl from './locales/nl/portal.json';
import damageWaiver_ru from './locales/ru/damageWaiver.json';
import damageWaiverResult_ru from './locales/ru/damageWaiverResult.json';
import portal_ru from './locales/ru/portal.json';
import damageWaiver_ar from './locales/ar/damageWaiver.json';
import damageWaiverResult_ar from './locales/ar/damageWaiverResult.json';
import portal_ar from './locales/ar/portal.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { damageWaiver: damageWaiver_en, damageWaiverResult: damageWaiverResult_en, portal: portal_en },
    es: { damageWaiver: damageWaiver_es, damageWaiverResult: damageWaiverResult_es, portal: portal_es },
    fr: { damageWaiver: damageWaiver_fr, damageWaiverResult: damageWaiverResult_fr, portal: portal_fr },
    de: { damageWaiver: damageWaiver_de, damageWaiverResult: damageWaiverResult_de, portal: portal_de },
    pt: { damageWaiver: damageWaiver_pt, damageWaiverResult: damageWaiverResult_pt, portal: portal_pt },
    it: { damageWaiver: damageWaiver_it, damageWaiverResult: damageWaiverResult_it, portal: portal_it },
    zh: { damageWaiver: damageWaiver_zh, damageWaiverResult: damageWaiverResult_zh, portal: portal_zh },
    ja: { damageWaiver: damageWaiver_ja, damageWaiverResult: damageWaiverResult_ja, portal: portal_ja },
    ko: { damageWaiver: damageWaiver_ko, damageWaiverResult: damageWaiverResult_ko, portal: portal_ko },
    nl: { damageWaiver: damageWaiver_nl, damageWaiverResult: damageWaiverResult_nl, portal: portal_nl },
    ru: { damageWaiver: damageWaiver_ru, damageWaiverResult: damageWaiverResult_ru, portal: portal_ru },
    ar: { damageWaiver: damageWaiver_ar, damageWaiverResult: damageWaiverResult_ar, portal: portal_ar },
  },
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
